module.exports = __webpack_public_path__ + "static/media/nav-icon-notifications.2bca7d23.svg";